import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import QRCode from "react-qr-code";
import { colors } from "../ui/colors";

const MobileAppDownloadPage = () => {
  const androidApkUrl = "https://flownect-media-dev.s3.us-west-1.amazonaws.com/dist/latest/flownect-mobile.release.0.0.3.apk"; // Cambiar por tu URL real
  const iosStoreUrl = "https://apps.apple.com/app/idXXXXXXXXX"; // Cambiar por URL real
  const qrLink = "https://your-domain.com/download"; // URL general del QR

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "var(--fx-surface-sunken, #F8FAFC)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 2,
      }}
    >
      <Card
        elevation={4}
        sx={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 4,
          padding: "24px 20px",
          textAlign: "center",
        }}
      >
        <CardContent>
          <Box sx={{ mb: 2 }}>
            <img src="https://connectacleaner-dev.s3.us-west-1.amazonaws.com/logo.png" alt="Flownect Logo" style={{ width: 110 }} />
          </Box>

          <Typography variant="h5" fontWeight={700} gutterBottom>
            Descargar Flownect
          </Typography>

          <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
            Escanea el código QR o usa los botones para instalar la aplicación.
          </Typography>

          <Box
            sx={{
              background: "var(--fx-surface-muted, #F1F5F9)",
              borderRadius: 3,
              p: 2,
              display: "flex",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <QRCode value={qrLink} size={180} />
          </Box>

          <Stack spacing={2}>
            <Button
              variant="contained"
              fullWidth
              size="large"
              sx={{
                backgroundColor: colors.orange.base,
                ":hover": { backgroundColor:  colors.orange.base },
                borderRadius: 2,
              }}
              href={androidApkUrl}
            >
              Descargar para Android (APK)
            </Button>

            <Button
              variant="contained"
              fullWidth
              size="large"
              sx={{
                backgroundColor: "#007aff",
                ":hover": { backgroundColor: "#0062cc" },
                borderRadius: 2,
              }}
              href={iosStoreUrl}
              target="_blank"
            >
              Ir a App Store (iOS)
            </Button>
          </Stack>

          <Typography variant="caption" sx={{ mt: 3, display: "block", color: "text.secondary" }}>
            Compatible con Android y iOS
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default MobileAppDownloadPage;
